import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import "@/index.css"
import { App, LoginPage } from "@/App"

const rootEl = document.getElementById("root")
if (!rootEl) throw new Error("missing #root")

function renderApp(account?: import("@azure/msal-browser").AccountInfo) {
  createRoot(rootEl!).render(
    <StrictMode>
      <App
        account={account}
        onSignOut={
          account
            ? () => {
                void import("@/auth").then(({ signOutMicrosoftAccount }) =>
                  signOutMicrosoftAccount(),
                )
              }
            : undefined
        }
      />
    </StrictMode>,
  )
}

if (import.meta.env.DEV) {
  if (window.location.pathname === "/login") {
    window.history.replaceState(null, "", "/")
  }

  renderApp()
} else {
  import("@/auth")
    .then(({ getMicrosoftAccount, signInMicrosoftAccount }) =>
      getMicrosoftAccount().then((account) => {
        if (!account) {
          if (window.location.pathname !== "/login") {
            window.location.replace("/login")
            return
          }

          createRoot(rootEl).render(
            <StrictMode>
              <LoginPage
                onSignIn={() => {
                  window.history.replaceState(null, "", "/")
                  void signInMicrosoftAccount()
                }}
              />
            </StrictMode>,
          )
          return
        }

        if (window.location.pathname === "/login") {
          window.history.replaceState(null, "", "/")
        }

        renderApp(account)
      }),
    )
    .catch((error: unknown) => {
      console.error("Microsoft sign-in failed", error)
      rootEl.textContent = "Microsoft sign-in could not be completed."
    })
}
